// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";

function V3CustomTableRow(props) {
  var children = props.children;
  var match = Curry._1(V3CustomTableContext$LiteracyplanetTupperware.use, undefined);
  var kind = match.kind;
  if (typeof kind === "object") {
    if (kind.TAG === "HighlightResponseSets") {
      return React.createElement("div", {
                  className: "pilotHighlightQuestionSetContainer"
                }, children);
    } else if (kind.hasStem) {
      return React.createElement("div", {
                  className: "pilot-multi-response-sets-row"
                }, children);
    } else {
      return React.createElement("div", {
                  className: "pilot-multi-response-sets-row-no-stem"
                }, children);
    }
  }
  switch (kind) {
    case "GridMatchLeftToRight" :
        return React.createElement("tr", {
                    className: "gridMatchLeftToRightRow"
                  }, children);
    case "GridMatchRightToLeft" :
        return React.createElement("div", {
                    className: "gridMatchRightToLeftRow"
                  }, children);
    case "InstructionAndHint" :
        return React.createElement("div", {
                    className: ""
                  }, children);
    
  }
}

var make = V3CustomTableRow;

var $$default = V3CustomTableRow;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
